import Vue from 'vue'
import Router from 'vue-router'
import store from '@/framework/store'
import routes from './routes'

Vue.use(Router)

const router = new Router({
  routes
})

const bypassUrls = [ '/', '/forgot-password', '/register', '/style-guide' ]

router.beforeEach((to, from, next) => {
  // update show navigation on route change
  store.commit('route/updateShowNavigation', !to.meta.hideNavigation)

  // check if url requires user to be logged in
  if (!bypassUrls.includes(to.path) && !store.getters['user/isLoggedIn']) {
    next('/')
    return
  }

  // check if a specific required auth is required
  if (to.matched.some(record => record.meta.requiredAuth)) {
    let match = to.matched.find(record => record.meta.requiredAuth)
    if (!store.getters[`user/${match.meta.requiredAuth}`]) {
      next('/not-authorized')
      return
    }
  }

  next()
})

export default router
